var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4995_34398)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "#0061FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5129 36.0147L49.0047 24.5059L37.5508 36.2897L46.0134 44.7523L46.0633 45.4812L30.6179 30.0358L23.221 37.3181L29.7413 43.8384L20.0723 60.6161L75.6291 116.173L112.214 78.4303L64.0055 30.2219L60.5129 36.0147Z",
    fill: "#004FCF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4995_34398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 38.8398C48.0359 38.8398 51.7129 35.1628 51.7129 30.627C51.7129 26.0911 48.0359 22.4141 43.5 22.4141C38.9641 22.4141 35.2871 26.0911 35.2871 30.627C35.2871 35.1628 38.9641 38.8398 43.5 38.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1139 38.8392C62.9814 38.8392 65.306 36.5146 65.306 33.6471C65.306 30.7796 62.9814 28.4551 60.1139 28.4551C57.2464 28.4551 54.9219 30.7796 54.9219 33.6471C54.9219 36.5146 57.2464 38.8392 60.1139 38.8392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8854 38.8392C29.7529 38.8392 32.0775 36.5146 32.0775 33.6471C32.0775 30.7796 29.7529 28.4551 26.8854 28.4551C24.0179 28.4551 21.6934 30.7796 21.6934 33.6471C21.6934 36.5146 24.0179 38.8392 26.8854 38.8392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 43.5016C29.9569 41.8271 28.106 42.0488 25.7428 42.0488C22.2085 42.0488 19.333 44.9072 19.333 48.4199V58.7294C19.333 60.255 20.5782 61.4954 22.1093 61.4954C28.7199 61.4954 27.9235 61.615 27.9235 61.2103C27.9235 53.905 27.0582 48.5476 32.0007 43.5016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7475 42.088C41.6199 41.7437 38.0322 42.0919 34.9377 44.6462C29.7591 48.7942 30.7557 54.3793 30.7557 61.2117C30.7557 63.0194 32.2265 64.5176 34.0616 64.5176C53.988 64.5176 54.781 65.1604 55.9626 62.5437C56.3502 61.6588 56.244 61.94 56.244 53.4746C56.244 46.7508 50.422 42.088 45.7475 42.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2569 42.0485C58.8808 42.0485 57.0401 41.8292 54.999 43.5014C59.9046 48.5099 59.0762 53.5017 59.0762 61.2101C59.0762 61.6173 58.4151 61.4952 64.7912 61.4952C66.3772 61.4952 67.6667 60.2104 67.6667 58.631V48.4197C67.6667 44.907 64.7912 42.0485 61.2569 42.0485Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4995_34398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4995_34398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.3333,
    height: 48.3333,
    fill: "white",
    transform: "translate(19.333 19.334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.cedcb3eb6725559e1d97cc7b64c72a7f.svg";
export { ForwardRef as ReactComponent };